/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type GetJwtFromKeyRequestBody = {
  /**
   * JWT audience (aud) claim for the exchanged token. Set this to the target API/service URL that should accept the token.
   */
  audience: string;
  /**
   * Your external user identifier to place in the JWT subject (sub) claim. Must be 1–150 printable-ASCII characters and not the wildcard `*`.
   */
  externalUserId: string;
  /**
   * Token lifetime in seconds. Must be between 300 (5 minutes) and 2592000 (30 days). Defaults to 3600 (1 hour).
   */
  expiresIn?: number | undefined;
  /**
   * Optional subset of the API key's scopes to embed in the token (e.g. read:responses). The exchanged token is attenuated to this set at the gateway perimeter. If omitted, all of the key's scopes are embedded (no attenuation).
   */
  permissions?: Array<string> | undefined;
};

export type GetJwtFromKeyRequest = {
  /**
   * Optional external end-user identifier forwarded by the API gateway.
   */
  xOnBehalfOf?: string | undefined;
  requestBody: GetJwtFromKeyRequestBody;
};

/**
 * Successfully exchanged API key for a JWT token
 */
export type GetJwtFromKeyResponseBody = {
  /**
   * Signed JWT exchange token to use when calling downstream services.
   */
  token: string;
};

/** @internal */
export const GetJwtFromKeyRequestBody$inboundSchema: z.ZodType<
  GetJwtFromKeyRequestBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  audience: z.string(),
  externalUserId: z.string(),
  expiresIn: z.number().default(3600),
  permissions: z.array(z.string()).optional(),
});
/** @internal */
export type GetJwtFromKeyRequestBody$Outbound = {
  audience: string;
  externalUserId: string;
  expiresIn: number;
  permissions?: Array<string> | undefined;
};

/** @internal */
export const GetJwtFromKeyRequestBody$outboundSchema: z.ZodType<
  GetJwtFromKeyRequestBody$Outbound,
  z.ZodTypeDef,
  GetJwtFromKeyRequestBody
> = z.object({
  audience: z.string(),
  externalUserId: z.string(),
  expiresIn: z.number().default(3600),
  permissions: z.array(z.string()).optional(),
});

export function getJwtFromKeyRequestBodyToJSON(
  getJwtFromKeyRequestBody: GetJwtFromKeyRequestBody,
): string {
  return JSON.stringify(
    GetJwtFromKeyRequestBody$outboundSchema.parse(getJwtFromKeyRequestBody),
  );
}
export function getJwtFromKeyRequestBodyFromJSON(
  jsonString: string,
): SafeParseResult<GetJwtFromKeyRequestBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetJwtFromKeyRequestBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetJwtFromKeyRequestBody' from JSON`,
  );
}

/** @internal */
export const GetJwtFromKeyRequest$inboundSchema: z.ZodType<
  GetJwtFromKeyRequest,
  z.ZodTypeDef,
  unknown
> = z.object({
  "X-On-Behalf-Of": z.string().optional(),
  RequestBody: z.lazy(() => GetJwtFromKeyRequestBody$inboundSchema),
}).transform((v) => {
  return remap$(v, {
    "X-On-Behalf-Of": "xOnBehalfOf",
    "RequestBody": "requestBody",
  });
});
/** @internal */
export type GetJwtFromKeyRequest$Outbound = {
  "X-On-Behalf-Of"?: string | undefined;
  RequestBody: GetJwtFromKeyRequestBody$Outbound;
};

/** @internal */
export const GetJwtFromKeyRequest$outboundSchema: z.ZodType<
  GetJwtFromKeyRequest$Outbound,
  z.ZodTypeDef,
  GetJwtFromKeyRequest
> = z.object({
  xOnBehalfOf: z.string().optional(),
  requestBody: z.lazy(() => GetJwtFromKeyRequestBody$outboundSchema),
}).transform((v) => {
  return remap$(v, {
    xOnBehalfOf: "X-On-Behalf-Of",
    requestBody: "RequestBody",
  });
});

export function getJwtFromKeyRequestToJSON(
  getJwtFromKeyRequest: GetJwtFromKeyRequest,
): string {
  return JSON.stringify(
    GetJwtFromKeyRequest$outboundSchema.parse(getJwtFromKeyRequest),
  );
}
export function getJwtFromKeyRequestFromJSON(
  jsonString: string,
): SafeParseResult<GetJwtFromKeyRequest, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetJwtFromKeyRequest$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetJwtFromKeyRequest' from JSON`,
  );
}

/** @internal */
export const GetJwtFromKeyResponseBody$inboundSchema: z.ZodType<
  GetJwtFromKeyResponseBody,
  z.ZodTypeDef,
  unknown
> = z.object({
  token: z.string(),
});
/** @internal */
export type GetJwtFromKeyResponseBody$Outbound = {
  token: string;
};

/** @internal */
export const GetJwtFromKeyResponseBody$outboundSchema: z.ZodType<
  GetJwtFromKeyResponseBody$Outbound,
  z.ZodTypeDef,
  GetJwtFromKeyResponseBody
> = z.object({
  token: z.string(),
});

export function getJwtFromKeyResponseBodyToJSON(
  getJwtFromKeyResponseBody: GetJwtFromKeyResponseBody,
): string {
  return JSON.stringify(
    GetJwtFromKeyResponseBody$outboundSchema.parse(getJwtFromKeyResponseBody),
  );
}
export function getJwtFromKeyResponseBodyFromJSON(
  jsonString: string,
): SafeParseResult<GetJwtFromKeyResponseBody, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => GetJwtFromKeyResponseBody$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'GetJwtFromKeyResponseBody' from JSON`,
  );
}
